webpackJsonp([19],{

/***/ 95:
/***/ (function(module, exports, __webpack_require__) {

 true ? console.log('Production mode!') : require('__page/index.html');
var mc = __webpack_require__(0);
mc.runVue(['Slider', 'Navigation', 'selectList']);
mc.runComponents(['rating']);
mc.runFooter();
$('body').on('ajaxResponse', function () {
	mc.runVue(['selectList']);
});

//if (module.hot) {
//	module.hot.accept('./print.js', function() {
//		console.log('Accepting the updated printMe module!');
//		printMe();
//	})
//}

// var offset = $('.fixed-header').offset();
// $(function() {
// 	var $window = $(window);
// 	var $sidebar = $(".fixed-header");
// 	var $sidebarTop = $sidebar.position().top;
// 		console.log($sidebarTop);
// 	var $sidebarHeight = $sidebar.height();
// 	var $footer = $('.footer');
// 	var $footerTop = $footer.position().top;
//
// 	$window.scroll(function(event) {
// 		$sidebar.addClass("fixed");
// 		var $scrollTop = $window.scrollTop();
// 		var $topPosition = Math.max(0, $sidebarTop - $scrollTop);
//
// 		if ($scrollTop + $sidebarHeight > $footerTop) {
// 			var $topPosition = Math.min($topPosition, $footerTop - $scrollTop - $sidebarHeight);
// 		}
//
// 		$sidebar.css("top", $topPosition);
// 	});
// });
// console.log($('.fixed-header').offset());
// console.log('_______________');
// $(window).scroll(function() {
// 	// $('.fixed-header').offset().top = $(window).scrollTop();
// 	$('.fixed-header').css('top', $(window).scrollTop());
// 	// console.log($('.fixed-header').offset());
// });

/***/ })

},[95]);


// WEBPACK FOOTER //
// bundles/index.bundle.js